export const categories = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球顶级足球赛事，五大联赛、欧冠、世界杯等精彩赛事一网打尽',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20with%20green%20grass%20field%20under%20dramatic%20stadium%20lights%2C%20atmospheric%20sports%20photography%2C%20wide%20angle%20view%20of%20packed%20stadium%2C%20clean%20composition%2C%20cinematic%20lighting%2C%20subtle%20dark%20background&width=800&height=600&seq=cat-football&orientation=landscape',
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA等顶级篮球联赛实时追踪，精彩扣篮、绝杀瞬间不容错过',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20lighting%2C%20orange%20basketball%20rim%20closeup%2C%20arena%20atmosphere%2C%20sports%20photography%2C%20clean%20dark%20background%2C%20cinematic%20mood&width=800&height=600&seq=cat-basketball&orientation=landscape',
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-medal-line',
    description: '四大满贯赛事深度解读，ATP/WTA巡回赛实时比分与专业分析',
    color: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20with%20yellow%20tennis%20ball%20on%20clay%20surface%2C%20dramatic%20sports%20lighting%2C%20clean%20composition%2C%20atmospheric%20arena%20photography%2C%20soft%20dark%20background%2C%20cinematic%20mood&width=800&height=600&seq=cat-tennis&orientation=landscape',
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2等顶级电竞赛事，专业数据与深度复盘',
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20colorful%20LED%20lights%2C%20competitive%20gaming%20atmosphere%2C%20wide%20angle%20stadium%20view%2C%20clean%20dark%20background%2C%20cinematic%20lighting%2C%20futuristic%20mood&width=800&height=600&seq=cat-esports&orientation=landscape',
  },
  {
    slug: 'formula1',
    name: 'F1赛车',
    icon: 'ri-steering-2-line',
    description: 'F1世界一级方程式锦标赛全程追踪，排位赛、正赛深度分析',
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20speeding%20on%20track%20with%20motion%20blur%2C%20dramatic%20racing%20atmosphere%2C%20professional%20motorsport%20photography%2C%20clean%20dark%20background%2C%20cinematic%20lighting&width=800&height=600&seq=cat-f1&orientation=landscape',
  },
];

export const featuredArticles = [
  {
    slug: 'champions-league-final-2026',
    title: '欧冠决赛：皇马 vs 曼城，巅峰对决一触即发',
    excerpt: '2025-26赛季欧冠决赛将在伊斯坦布尔打响，卫冕冠军皇家马德里迎战英超霸主曼城，双方实力旗鼓相当，谁能捧起大耳朵杯？',
    category: 'football',
    image: 'https://readdy.ai/api/search-image?query=Champions%20League%20trophy%20on%20pedestal%20inside%20magnificent%20stadium%2C%20dramatic%20lighting%2C%20premium%20sports%20photography%2C%20clean%20dark%20background%2C%20cinematic%20atmosphere%2C%20golden%20trophy%20glowing&width=1200&height=800&seq=article-cl-final&orientation=landscape',
    date: '2026-08-05',
    readTime: '8分钟',
    views: 128500,
  },
  {
    slug: 'nba-finals-2026',
    title: 'NBA总决赛：凯尔特人王朝崛起，布朗荣膺FMVP',
    excerpt: '波士顿凯尔特人以4-2击败对手夺得队史第19座总冠军，杰伦·布朗凭借场均31.5分的出色表现获得总决赛最有价值球员。',
    category: 'basketball',
    image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20championship%20trophy%20on%20court%20with%20confetti%20falling%2C%20dramatic%20arena%20lighting%2C%20professional%20sports%20photography%2C%20clean%20dark%20background%2C%20celebration%20atmosphere&width=1200&height=800&seq=article-nba-finals&orientation=landscape',
    date: '2026-08-03',
    readTime: '10分钟',
    views: 96200,
  },
  {
    slug: 'wimbledon-2026-review',
    title: '温网2026：新生代球员崛起，网坛格局迎来巨变',
    excerpt: '2026年温布尔登网球锦标赛见证了多位年轻选手的突破，男单决赛上演五盘大战，女单赛场同样精彩纷呈。',
    category: 'tennis',
    image: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20championship%20trophy%20on%20green%20grass%20court%2C%20elegant%20sports%20photography%2C%20clean%20composition%2C%20soft%20natural%20lighting%2C%20prestigious%20atmosphere&width=1200&height=800&seq=article-wimbledon&orientation=landscape',
    date: '2026-08-01',
    readTime: '7分钟',
    views: 75300,
  },
];

export const allArticles = [
  ...featuredArticles,
  {
    slug: 'premier-league-preview',
    title: '英超新赛季前瞻：六大豪门引援分析，谁最有可能夺冠？',
    excerpt: '2026-27赛季英超即将拉开帷幕，各支豪门球队在转会市场上动作频频，我们为你详细分析各队实力变化和夺冠前景。',
    category: 'football',
    image: 'https://readdy.ai/api/search-image?query=English%20Premier%20League%20trophy%20and%20football%20on%20green%20grass%20pitch%2C%20professional%20sports%20photography%2C%20clean%20dark%20background%2C%20cinematic%20lighting%2C%20premium%20atmosphere&width=1200&height=800&seq=article-epl&orientation=landscape',
    date: '2026-07-30',
    readTime: '12分钟',
    views: 89200,
  },
  {
    slug: 'lpl-summer-2026',
    title: 'LPL夏季赛季后赛：四强争霸，谁能代表LPL出征世界赛？',
    excerpt: '2026年LPL夏季赛季后赛进入白热化阶段，JDG、BLG、TES和WBG四支队伍争夺冠军奖杯和世界赛名额。',
    category: 'esports',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20gaming%20stage%20and%20large%20screens%2C%20colorful%20LED%20lights%2C%20competitive%20atmosphere%2C%20clean%20dark%20background%2C%20futuristic%20lighting&width=1200&height=800&seq=article-lpl&orientation=landscape',
    date: '2026-07-28',
    readTime: '6分钟',
    views: 105400,
  },
  {
    slug: 'f1-monaco-2026',
    title: 'F1摩纳哥大奖赛：维斯塔潘刷新赛道纪录，夺得赛季第六冠',
    excerpt: '红牛车队马克斯·维斯塔潘在蒙特卡洛赛道上演完美表现，以刷新赛道纪录的成绩夺得2026年摩纳哥大奖赛冠军。',
    category: 'formula1',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20racing%20car%20cornering%20on%20Monaco%20street%20circuit%2C%20dramatic%20motion%20blur%2C%20professional%20motorsport%20photography%2C%20clean%20composition%2C%20cinematic%20lighting&width=1200&height=800&seq=article-f1-monaco&orientation=landscape',
    date: '2026-07-25',
    readTime: '5分钟',
    views: 67800,
  },
  {
    slug: 'world-cup-2026-qualifiers',
    title: '世界杯亚洲区预选赛：中国队关键战役前瞻',
    excerpt: '2026年世界杯亚洲区预选赛进入最后冲刺阶段，中国队将在主场迎战关键对手，国足出线形势分析。',
    category: 'football',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20on%20stadium%20pitch%2C%20red%20jersey%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20clean%20dark%20background%2C%20cinematic%20atmosphere&width=1200&height=800&seq=article-wcq&orientation=landscape',
    date: '2026-07-22',
    readTime: '9分钟',
    views: 215600,
  },
  {
    slug: 'nba-draft-2026',
    title: 'NBA选秀大会：状元之争尘埃落定，雷霆获重建基石',
    excerpt: '2026年NBA选秀大会上，俄克拉荷马雷霆队用状元签选中了来自杜克大学的超级新星，各队选秀评级全面分析。',
    category: 'basketball',
    image: 'https://readdy.ai/api/search-image?query=NBA%20draft%20stage%20with%20team%20logos%2C%20dramatic%20arena%20lighting%2C%20professional%20sports%20photography%2C%20clean%20dark%20background%2C%20premium%20atmosphere&width=1200&height=800&seq=article-nba-draft&orientation=landscape',
    date: '2026-07-20',
    readTime: '7分钟',
    views: 83400,
  },
  {
    slug: 'us-open-tennis-2026',
    title: '美网前瞻：硬地之王争夺战，谁能加冕年度最后一项大满贯？',
    excerpt: '2026年美国网球公开赛即将在纽约法拉盛公园拉开帷幕，德约科维奇、阿尔卡拉斯等名将蓄势待发，年度最后一项大满贯花落谁家？',
    category: 'tennis',
    image: 'https://readdy.ai/api/search-image?query=US%20Open%20tennis%20stadium%20at%20night%20with%20floodlights%2C%20blue%20hard%20court%2C%20dramatic%20sports%20photography%2C%20clean%20composition%2C%20cinematic%20atmosphere&width=1200&height=800&seq=article-usopen&orientation=landscape',
    date: '2026-07-18',
    readTime: '8分钟',
    views: 61200,
  },
  {
    slug: 'lck-finals-2026',
    title: 'LCK夏季赛决赛：T1 vs GEN，传奇对决再续',
    excerpt: '韩国LCK联赛夏季赛决赛将在首尔举行，T1与GEN这对宿敌再度相遇，Faker能否带领T1重返巅峰？',
    category: 'esports',
    image: 'https://readdy.ai/api/search-image?query=Korean%20esports%20arena%20with%20gaming%20stage%20and%20cheering%20crowd%2C%20dramatic%20lighting%2C%20professional%20esports%20photography%2C%20clean%20dark%20background%2C%20competitive%20atmosphere&width=1200&height=800&seq=article-lck&orientation=landscape',
    date: '2026-07-15',
    readTime: '6分钟',
    views: 91600,
  },
];

export const faqItems = [
  {
    question: '九游体育提供哪些赛事的直播服务？',
    answer: '九游体育平台覆盖足球、篮球、网球、电竞、F1赛车等主流体育赛事，为用户提供高清直播、实时数据更新和赛事回放服务。我们的直播源稳定可靠，确保您不错过任何精彩瞬间。',
  },
  {
    question: '如何查看赛事实时数据和深度分析？',
    answer: '在九游体育平台，您可以通过点击任意赛事进入详情页面，查看实时比分、球队/球员统计数据、历史交锋记录以及专业分析师撰写的赛前预测和赛后复盘，帮助您全面了解赛事走势。',
  },
  {
    question: '九游体育平台是否需要注册才能使用？',
    answer: '九游体育大部分内容对所有用户开放，您可以直接浏览赛事资讯、观看直播和查看数据。注册成为会员后，您还可以享受个性化赛事提醒、收藏关注的球队和获取独家分析报告等增值服务。',
  },
  {
    question: '平台上的数据分析是由专业人士提供的吗？',
    answer: '是的，九游体育拥有一支由资深体育分析师和数据科学家组成的专业团队，所有数据分析和赛事解读均来自具备多年行业经验的专业人士，确保为您提供准确、深度的体育赛事资讯。',
  },
  {
    question: '九游体育支持哪些设备访问？',
    answer: '九游体育平台全面支持PC端、平板和手机等各类设备访问，采用响应式设计，确保您在任何设备上都能获得流畅、优质的体育赛事观看体验。',
  },
  {
    question: '如何联系九游体育的客服团队？',
    answer: '您可以通过官方网站的"联系我们"页面提交反馈表单，或发送邮件至 support@9yousports.com，我们的客服团队将在24小时内回复您的咨询。',
  },
];

export const siteInfo = {
  name: '九游体育',
  title: '九游体育 - 官方体育赛事平台',
  description: '九游体育是专业的体育赛事平台，覆盖足球、篮球、网球等热门赛事，提供实时赛况、数据分析、赛事直播及体育资讯服务。加入九游体育，享受极致体育娱乐体验，让每一场比赛都精彩无限。',
  keywords: '九游体育,九游体育官网,九游体育平台,九游体育赛事直播,九游体育足球,九游体育篮球,九游体育数据分析',
  url: 'https://www.9yousports.com',
  email: 'support@9yousports.com',
  phone: '400-888-9999',
  address: '北京市朝阳区体育中心路88号九游大厦',
  founded: '2018',
  teamSize: '500+',
  users: '5000万+',
  matches: '10万+',
};

export const brandStory = {
  title: '关于九游体育',
  subtitle: '让每一场比赛都精彩无限',
  paragraphs: [
    '九游体育成立于2018年，总部位于中国北京，是国内领先的专业体育赛事平台。自成立以来，我们始终致力于为全球体育爱好者提供最全面、最及时、最专业的体育赛事服务，让每一位用户都能享受到极致的体育娱乐体验。',
    '我们的团队由来自全球顶尖科技公司和体育机构的专业人士组成，涵盖赛事数据分析、人工智能、新媒体运营等多个领域。凭借深厚的行业积累和技术实力，九游体育已发展成为覆盖足球、篮球、网球、电竞、F1赛车等数十个体育项目的综合性平台。',
    '九游体育始终秉持"专业、真实、及时"的核心价值观，通过与全球各大体育联盟和赛事组织建立深度合作关系，确保为用户提供第一手的赛事资讯和权威的数据分析。我们相信，体育的力量不仅在于竞技本身，更在于它能够连接人与人之间的情感纽带。',
  ],
};

export const honors = [
  { year: '2026', title: '中国最佳体育科技平台', issuer: '中国互联网协会' },
  { year: '2025', title: '年度最具影响力体育App', issuer: '体育产业峰会' },
  { year: '2025', title: '国家高新技术企业认证', issuer: '科技部' },
  { year: '2024', title: '中国体育产业创新奖', issuer: '中国体育总局' },
  { year: '2024', title: '用户满意度金口碑奖', issuer: '中国质量协会' },
  { year: '2023', title: '最佳体育数据服务商', issuer: '亚洲体育产业联盟' },
];

export const stats = [
  { value: '5000万+', label: '累计用户', icon: 'ri-user-line' },
  { value: '10万+', label: '赛事覆盖', icon: 'ri-trophy-line' },
  { value: '50+', label: '合作联盟', icon: 'ri-group-line' },
  { value: '99.9%', label: '直播稳定性', icon: 'ri-signal-wifi-line' },
];